import {JobState} from "../../interfaces/store/reducers/jobState";
import {
    CLEAR_JOB_LIST_DATA,
    DESTROY_CONFIRM_CLAIM_DIALOG,
    DESTROY_JOB_DRAWER,
    OPEN_JOB_EDITOR,
    RESET_JOB_NOTIFICATION,
    SET_ACTIVE_JOB_TYPE,
    SET_JOB_FILTER_TYPE,
    SET_JOB_LIST,
    SET_JOB_LIST_CURSOR,
    SET_JOB_PHASE_WORKFLOW_DEFINITIONS,
    SET_JOB_SEARCH,
    SET_PHASE_CONFIG_LIST,
    SET_SELECTED_JOB,
    SHOW_CONFIRM_CLAIM_DIALOG,
    SHOW_JOB_DRAWER,
    SHOW_JOB_NOTIFICATION,
    UPDATE_JOB_LIST,
} from "../actions/availableActions";
import {
    ClearJobListDataAction,
    DestroyConfirmClaimDialogAction,
    DestroyJobDrawerAction,
    OpenJobEditorAction,
    ResetJobNotificationAction,
    SetActiveJobTypeAction,
    SetJobFilterTypeAction,
    SetJobListAction,
    SetJobListCursorAction,
    SetJobPhaseWorkflowDefinitionsAction,
    SetJobSearchAction,
    SetPhaseConfigListAction,
    SetSelectedJobAction,
    ShowConfirmClaimDialogAction,
    ShowJobDrawerAction,
    ShowJobNotificationAction,
    UpdateJobListAction,
} from "../../interfaces/store/actions/job";
import {JobFilterType, JobType} from "../../enums/enums";
import {DrawerTabs} from "../../utils/constants";

const initialState: JobState = {
    cursor: null,
    list: [],
    searchValue: "",
    selectedJob: null,
    workflowDefinitions: [],
    phaseConfigList: {},
    activeJobType: JobType.FEATURED,
    filter: JobFilterType.CLAIMABLE,
    isDrawerVisible: false,
    isConfirmClaimVisible: false,
    notificationData: null,
    activeJobDrawerTab: DrawerTabs.STATS,
    openEditor: false,
};

type AvailableActions =
    SetJobListAction
    |SetJobSearchAction
    |SetJobListCursorAction
    |SetPhaseConfigListAction
    |SetActiveJobTypeAction
    |SetJobFilterTypeAction
    |ClearJobListDataAction
    |SetSelectedJobAction
    |UpdateJobListAction
    |ShowJobDrawerAction
    |ShowConfirmClaimDialogAction
    |DestroyConfirmClaimDialogAction
    |SetJobPhaseWorkflowDefinitionsAction
    |ShowJobNotificationAction
    |ResetJobNotificationAction
    |DestroyJobDrawerAction
    |OpenJobEditorAction;

const jobReducer = (state:JobState = initialState, action: AvailableActions): JobState => {
    switch (action.type) {
        case SET_JOB_SEARCH:
            return {
                ...state,
                searchValue: action.payload || "",
            };
        case SET_JOB_PHASE_WORKFLOW_DEFINITIONS:
            return {
                ...state,
                workflowDefinitions: action.payload,
            };
        case SET_JOB_LIST:
            return {
                ...state,
                list: action.payload,
            };
        case SET_JOB_LIST_CURSOR:
            return {
                ...state,
                cursor: action.payload,
            };
        case SET_PHASE_CONFIG_LIST:
            return {
                ...state,
                phaseConfigList: action.payload,
            };
        case UPDATE_JOB_LIST:
            return {
                ...state,
                list: [...state.list, ...action.payload],
            };
        case SET_ACTIVE_JOB_TYPE:
            return {
                ...state,
                activeJobType: action.payload,
            };
        case SET_JOB_FILTER_TYPE:
            return {
                ...state,
                filter: action.payload,
            };
        case SET_SELECTED_JOB:
            return {
                ...state,
                selectedJob: action.payload,
            };
        case SHOW_JOB_DRAWER:
            return {
                ...state,
                isDrawerVisible: true,
                activeJobDrawerTab: action.payload,
            };
        case SHOW_CONFIRM_CLAIM_DIALOG:
            return {
                ...state,
                isConfirmClaimVisible: true,
                selectedJob: action.payload,
            };
        case DESTROY_CONFIRM_CLAIM_DIALOG:
            return {
                ...state,
                isConfirmClaimVisible: false,
                selectedJob: null,
            };
        case DESTROY_JOB_DRAWER:
            return {
                ...state,
                isDrawerVisible: false,
            };
        case SHOW_JOB_NOTIFICATION:
            return {
                ...state,
                notificationData: action.payload,
            };
        case RESET_JOB_NOTIFICATION:
            return {
                ...state,
                notificationData: null,
            };
        case OPEN_JOB_EDITOR:
            return {
                ...state,
                openEditor: action.payload,
            };
        case CLEAR_JOB_LIST_DATA:
            return {
                ...state,
                list: [],
                cursor: null,
                selectedJob: null,
                searchValue: "",
                openEditor: false,
            };
        default:
            return state;
    }
};

export default jobReducer;
